import {WebGLRenderer} from "three";

export const killRenderer = (renderer: WebGLRenderer) => {
  setTimeout(() => {
    try {
      renderer.resetState();
      renderer.dispose();
      renderer.forceContextLoss();
    } catch {
      console.error("Не удалось освободить ресурсы");
    }
  }, 500);
};